import React from "react";
import "./intro.css";
import Lottie from "lottie-react";
import animationData from "../../lottie/l1.json";
// import self from "../../img/self.jpg";

const Intro = () => {
  return (
    <div className="i">
      <div className="i-left">
        <div className="i-left-wrapper">
          <h1 className="i-name">Hello! I'm Drishti 👋🏻 </h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">UI/UX Designer </div>
              <div className="i-title-item">Mobile Developer</div>
              <div className="i-title-item">Full-Stack Developer</div>
            </div>
          </div>
          {/* <p className="i-desc">
            I am <a href=""></a> Computer Science graduate currently pursuing
            Master of Science in Information Systems at Northeastern University
            with prior experience as a Software Developer.
          </p> */}
          <p className="i-desc">
            Welcome to my digital garden, My journey mastering
            Software development, improving as a developer, and advancing in the
            tech world.
          </p>
          <div className="button-wrapper">
            <button className="resume-button">
              <a
                href="https://drive.google.com/file/d/1Fnq66IJjxbJLLWA3Ysxi_vyiqr0uEfp1/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                Resume
              </a>
            </button>
            <button className="utube-button">
              <a
                href="https://www.youtube.com/c/BingeCode"
                target="_blank"
                rel="noreferrer"
              >
                YouTube Channel
              </a>
            </button>
          </div>
        </div>
      </div>

      <div className="i-right">
      {/* <img src={self} alt="" className="a-img" /> */}
        <Lottie
          animationData={animationData}
          loop={true}
          className="i-lottie"
        />
      </div>
    </div>
  );
};

export default Intro;
